import { useState } from 'react';

// Shared "cancel" confirmation modal for SO/Invoice cancellation — a single
// modal requiring TWO things before the Confirm button is enabled: a
// non-empty reason, and an explicit "I understand this is permanent"
// checkbox. Neither the reason nor the checkbox can be skipped.
export default function CancelConfirmModal({ title, itemLabel, onConfirm, onClose, confirming }) {
  const [reason, setReason] = useState('');
  const [acknowledged, setAcknowledged] = useState(false);

  const canConfirm = reason.trim().length > 0 && acknowledged && !confirming;

  return (
    <div className="acc-modal-overlay" onClick={onClose}>
      <div className="acc-modal" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <p>
          Cancelling <strong>{itemLabel}</strong> moves it out of the live tables permanently.
          This cannot be undone from the portal.
        </p>

        <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--acc-text)', display: 'block', marginBottom: 6 }}>
          Reason for cancellation <span style={{ color: 'var(--acc-danger)' }}>*</span>
        </label>
        <textarea
          className="acc-textarea"
          placeholder="Explain why this is being cancelled..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />

        <label className="acc-modal-checkbox">
          <input
            type="checkbox"
            checked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
          />
          I understand this action is permanent and cannot be undone.
        </label>

        <div className="acc-modal-actions">
          <button className="acc-btn" onClick={onClose} disabled={confirming}>Back</button>
          <button
            className="acc-btn acc-btn--danger"
            disabled={!canConfirm}
            onClick={() => onConfirm(reason.trim())}
          >
            {confirming ? 'Cancelling…' : 'Confirm Cancellation'}
          </button>
        </div>
      </div>
    </div>
  );
}
